<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Parámetros de configuración')"
      tabla="parcon"
      icono="mdi-application-cog"
      :campos="['cod-', 'des+', 'val', 'valpordef-', 'fechormod-']"
      busqueda-rapida
      :titulo-crud="$t ('parámetro de configuración')"
      :filas-por-pagina="500"
      permitir-modificar
      dense
    >
      <template v-slot:[`item.cod`]="{ item }">
        <span style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-weight: 500;">{{ item.cod }}</span>
      </template>
      <template v-slot:[`item.val`]="{ item }">
        <span style="font-family: monospace; font-weight: 600;">{{ item.val }}</span>
      </template>
    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
};
</script>

<style>
</style>